import { createSelector } from 'reselect';

// Preselectors
export const graphSelector = state => state.staticLookerDashboard.graphs;
export const eventNameSelector = state => state.staticLookerDashboard.eventMeta.name;
export const venueNameSelector = state => state.staticLookerDashboard.eventMeta.venue.name;
export const daysUntilEventSelector = state => state.staticLookerDashboard.eventMeta.days_until_event;
export const onsaleDateSelector = state => state.staticLookerDashboard.eventMeta.on_sale;
export const eventCapacitySelector = state => state.staticLookerDashboard.eventMeta.tm_stats.event_capacity;
export const maxCapacitySelector = state => state.staticLookerDashboard.eventMeta.venue.max_capacity;
export const eventDateSelector = state => state.staticLookerDashboard.eventMeta.event_date_local;
export const loadingSelector = state => state.staticLookerDashboard.loaders;
export const notificationSelectorRows = state => state.notifications.notifications.notifications;
export const notificationSelectorCount = state => state.notifications.notifications.notificationsCount;

// Reselect
export const graphsLoadingSelector = createSelector(loadingSelector, loading => loading.graphs);
export const metaLoadingSelector = createSelector(loadingSelector, loading => loading.meta);

export const primaryQtyLoadingSelector = createSelector(loadingSelector, loading => loading.primaryQty);

export const pastEventsLoadingSelector = createSelector(loadingSelector, loading => loading.pastEvents);
export const eventsThresholdsLoadingSelector = createSelector(loadingSelector, loading => loading.thresholdEvents);

export const graphsInfoSelector = state => state.staticLookerDashboard.graphsInfo;
